import { Response, RequestOptionsArgs } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { Subject } from 'rxjs/Subject';
import { BarGraphView } from './models/interpretation.model';

/**
  * The bar graph service is used to help display the bar charts
  * correctly between multiple system components.
 */
@Injectable()
export class BarGraphService {
  private $zoomScale: Subject<number> = new Subject<number>();
  private $smuInterval: Subject<number> = new Subject<number>();
  private $barGraphView: Subject<BarGraphView> = new Subject<BarGraphView>();
  private zoomScale: number = 1;
  private smuInterval: number = 1000;
  private barGraphView: BarGraphView = BarGraphView.Expanded;
  private ZOOM_SCALE_MAX_ZOOM: number = .125;

  /**
   * The bar graph service is used to help display the bar charts
   * correctly between multiple system components. 
   */
  constructor() {
    this.initialize();
  }

  public initialize() {
    this.$zoomScale.next(this.zoomScale);
    this.$smuInterval.next(this.smuInterval);
    this.$barGraphView.next(this.barGraphView);
  }

  /**
   * Gets the bar graph view used to determine how to display
   * the bars on the interpretation page.
   */
  public getBarGraphView(): Observable<BarGraphView> {
    this.initialize();
    return this.$barGraphView.asObservable();
  }

  /**
   * Sets the bar graph view. Can be Expanded or Compact. 
   * @param newView Can be BarGraphView.Expanded or BarGraphView.Compact.
   */
  public setBarGraphView(newView: BarGraphView) {
    this.barGraphView = newView;
    this.$barGraphView.next(newView);
  }

  /**
   * Returns the scale of zoom used when displaying the
   * bar charts on the interpretation bar view. 
   */
  public getZoomScale(): Observable<number> {
    this.initialize();
    return this.$zoomScale.asObservable();
  }

  /**
   * Returns an observable of the SMU interval
   * to be used displaying the bar charts on the
   * interpretation bar view. 
   */
  public getSmuInterval(): Observable<number> {
    this.initialize();
    return this.$smuInterval.asObservable();
  }

  /**
   * Increase the scale of zoom by a factor of 1.
   */
  public increaseZoomScale() {
    this.zoomScale++;
    this.$zoomScale.next(this.zoomScale);
  }
  /**
  * Decrease the scale of zoom by a factor of 1.
  * Zoom scale will not go below 1. 
  */
  public decreaseZoomScale() {
    if (this.zoomScale > 1) {
      this.zoomScale--;
      this.$zoomScale.next(this.zoomScale)
    } else if (this.zoomScale < this.ZOOM_SCALE_MAX_ZOOM) {
      return;
    } else {
      this.zoomScale = this.zoomScale / 2;
      this.$zoomScale.next(this.zoomScale);
    }
  }

  /**
  * Sets the smu interval distance displayed on the bar
  * graph on the interpretation page bar chart tab. 
  * @param {number} interval The interval (SMU)
  */
  public setSmuInterval(interval: number) {
    if (this.smuInterval > 0) {
      this.smuInterval = interval;
      this.$smuInterval.next(interval);
    }
  }



  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
}
